import React, { useState } from 'react';
import { FaBell } from 'react-icons/fa';
import { useNotifications } from '../contexts/NotificationContext';

const NotificationBell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { notifications, unreadCount, markNotificationAsRead } = useNotifications();

  const handleNotificationClick = (notification) => {
    // Implement navigation or action based on notification type
    markNotificationAsRead(notification.id);
  };

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 rounded-full hover:bg-white/20 transition-colors"
      >
        <FaBell className="text-white" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 bg-red-500 text-white rounded-full px-1.5 py-0.5 text-xs">
            {unreadCount}
          </span>
        )}
      </button>

      {isOpen && (
                // <div className="absolute right-0 mt-2 w-64 bg-white/20 backdrop-blur-lg rounded-lg shadow-lg border border-white/20 z-50">
        <div className="absolute right-0 mt-2 w-64 bg-gray-800 rounded-lg shadow-lg border border-white/20 z-50">
          <div className="p-4 border-b border-white/20">
            <h3 className="text-white font-semibold">Notifications</h3>
          </div>
          {notifications.length === 0 ? (
            <div className="p-4 text-center text-gray-400">
              No new notifications
            </div>
          ) : (
            <ul className="max-h-64 overflow-y-auto">
              {notifications.map(notification => (
                <li 
                  key={notification.id}
                  onClick={() => handleNotificationClick(notification)}
                  className={`p-3 hover:bg-gray-700 cursor-pointer border-b border-white/10 last:border-b-0 ${!notification.read ? 'bg-gray-900/30' : ''}`}
                >
                  <div className="flex items-start">
                    <div className="flex-grow">
                      <p className="text-sm text-white">{notification.message}</p>
                      <p className="text-xs text-gray-400">
                        {new Date(notification.createdAt.toDate()).toLocaleString()}
                      </p>
                    </div>
                    {!notification.read && (
                      <span className="w-3 h-3 bg-red-500 rounded-full ml-2 mt-1"></span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
